import ContractDetailTable from './ContractDetailTable';

export default ContractDetailTable;